import { CONSENT_DISPLAY_KINDS, CONSENT_DOC_ID, type UserConsent } from '@/shared/data-types';

/** 화면에 세우는 항목의 consentId — 판정 대상을 노출 대상과 같은 집합으로 묶는다. */
const DISPLAY_CONSENT_IDS = new Set<string>(
  CONSENT_DISPLAY_KINDS.map((kind) => CONSENT_DOC_ID[kind]),
);

/**
 * 필수 약관 중 미동의 항목이 있는지 — 약관 동의 온보딩(`/auth/consent`) 진입 판정 SSOT.
 *
 * 선택 항목(마케팅 수신 등)은 미동의여도 통과 — 게이트는 **필수만** 본다.
 *
 * **`CONSENT_DISPLAY_KINDS` 밖의 항목은 아예 세지 않는다.** 판정 대상이 폼의 노출 대상보다 넓으면
 * 데드락이 난다 — 화면에 없는 필수 항목이 미동의로 오는 순간 가드는 계속 온보딩으로 보내는데
 * 사용자는 그 항목을 체크할 수단이 없어 앱 진입 자체가 막힌다(위약금 CLU40 은 실제로 약관 목록에선
 * `required: true`, 프로필 동의에선 `false` 로 서로 다르게 온다).
 *
 * 호출처는 라우트 가드(`requireConsent`)와 `pages/consent`(이미 동의 완료면 pass-through).
 */
export function hasUnagreedRequired(consents: UserConsent[]): boolean {
  return consents.some(
    (consent) => DISPLAY_CONSENT_IDS.has(consent.consentId) && consent.required && !consent.agreed,
  );
}
